import { all } from "redux-saga/effects";
import getPinSaga from "./pin.saga";
import getIframeSaga from "./iframe.saga";
import signOut from "./signOut.saga";
import manifestSaga from "./manifest.saga";
export default function* rootSaga() {
  yield all([getPinSaga(), getIframeSaga(), signOut(), manifestSaga()]);
}
